<template>
  <div :class="['metric-bignum',smallClassString]">
    <div class="school-value">{{schoolValue}}</div>
    <div class="right-column">
      <div class="description metric">{{descDisplayText}}</div>
      <div class="description sub values-row">
        <div v-if="hasCompSlot" class="value-group comp">Comparison Group: {{compValue}}</div>
        <div v-if="hasDistSlot" class="value-group dist">District {{selectedSchoolDistrict}}: {{distValue}}</div>
        <div v-if="hasBoroSlot" class="value-group boro">{{selectedSchoolBorough}}: {{boroValue}}</div>
        <div v-if="hasCitySlot" class="value-group city">City: {{cityValue}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Component, { mixins } from 'vue-class-component'

import { MetadataDescMixin, MetadataFallbackTextMixin } from './metadata-mixin'

import { NS_CURRENT_REPORT } from '../const'

/* Valid Slot Names for this Component */
const SN_CITY = 'city_value'
const SN_DIST = 'dist_value'
const SN_BORO = 'boro_value'
const SN_COMP = 'comp_value'

@Component({
  computed: {
    ...mapGetters(NS_CURRENT_REPORT, [
      'selectedSchoolBorough',
      'selectedSchoolDistrict'
    ])
  }
})
export default class MetricBignum extends mixins(MetadataDescMixin, MetadataFallbackTextMixin) {
  isSmallNum = false

  /* Getters */

  get smallClassString () { return this.isSmallNum ? 'small' : '' }

  get cityValue () { return this.dispValueForSlotName(SN_CITY) }
  get distValue () { return this.dispValueForSlotName(SN_DIST) }
  get boroValue () { return this.dispValueForSlotName(SN_BORO) }
  get compValue () { return this.dispValueForSlotName(SN_COMP) }

  get hasCitySlot () { return this.hasSlotName(SN_CITY) }
  get hasDistSlot () { return this.hasSlotName(SN_DIST) }
  get hasBoroSlot () { return this.hasSlotName(SN_BORO) }
  get hasCompSlot () { return this.hasSlotName(SN_COMP) }

  get customTemplateText () {
    return this.useFallbackText ? this.fallbackText : undefined
  }
}

class MetricSmallnum extends MetricBignum {
  isSmallNum = true
}

export { MetricBignum, MetricSmallnum }

</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../css/const.scss';
.metric-bignum {
  display: flex;
  margin-bottom: 16px;
  .right-column {
    flex: 1;
  }
  .description {
    margin-bottom: 0px;
  }
}
.metric-bignum.small {
  .school-value {
    font-size: 18px;
    padding-left: 14px;
  }
}
.school-value {
  width: 64px;
  font-size: 24px;
  font-weight: bold;
  box-sizing: border-box;
}
.values-row {
  display: block;
}

/* Responsive rules */

@media screen and (max-width: $screen-width-1-column-large) {
.values-row {
  display: flex;
}
.value-group {
  padding-right: 24px;
}
}
@media screen and (max-width: $screen-width-1-column-medium) {
.values-row {
  display: block;
}
}
</style>



// WEBPACK FOOTER //
// src/components/sqs/2018/tab-mods/MetricBignum.vue